import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";


const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resendTimer, setResendTimer] = useState(0);

  const navigate = useNavigate();

  // Countdown timer for resend
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  const sendOtp = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/send-otp`, { phone });
      if (res.data.success) {
        setSessionId(res.data.sessionId);
        setStep(2);
        setResendTimer(30);
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("Error sending OTP");
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/verify-otp`, { sessionId, otp });
      if (res.data.success) {
        setStep(3);
      } else {
        alert(res.data.message || "OTP verification failed");
      }
    } catch (err) {
      alert("Error verifying OTP");
    }
  };

  const resetPassword = async () => {
    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/auth/reset-password`, {
        phone,
        newPassword,
      });
      if (res.data.success) {
        alert("Password reset successful! Please login.");
        navigate("/login");
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("Error resetting password");
    }
  };

  return (
    <PageWrapper>
      <Card>
        <BackButton onClick={() => navigate("/login")}>← Back</BackButton>
        <Title>Forgot Password</Title>

        {step === 1 && (
          <>
            <StyledInput
              type="text"
              placeholder="Enter Registered Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <StyledButton onClick={sendOtp}>Send OTP</StyledButton>
          </>
        )}

        {step === 2 && (
          <>
            <StyledInput
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <StyledButton onClick={verifyOtp}>Verify OTP</StyledButton>
            <StyledButton disabled={resendTimer > 0} onClick={sendOtp}>
              {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP"}
            </StyledButton>
          </>
        )}

        {step === 3 && (
          <>
            <StyledInput
              type="password"
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <StyledButton onClick={resetPassword}>Reset Password</StyledButton>
          </>
        )}
      </Card>
    </PageWrapper>
  );
};

export default ForgotPassword;

// ===================== STYLED COMPONENTS =====================
const PageWrapper = styled.div`
  background-color: #000;
  color: #f5d76e;
  font-family: "Segoe UI", sans-serif;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Card = styled.div`
  background-color: #111;
  padding: 2.5rem 2rem 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.7rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #f5d76e;
  background: #1a1a1a;
  color: #f5d76e;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #ffcc00;
  }
`;

const StyledButton = styled.button`
  width: 100%;
  padding: 0.8rem;
  border: none;
  border-radius: 8px;
  background-color: #f5d76e;
  color: #000;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 0.5rem;

  &:hover {
    background-color: #ffe58f;
  }

  &:disabled {
    background-color: #444;
    color: #999;
    cursor: not-allowed;
  }
`;

const BackButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: transparent;
  border: 1px solid #937676;
  color: #f5d76e;
  font-size: 0.9rem;
  border-radius: 6px;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5d76e;
    color: #000;
  }
`;